import { Reducer } from 'redux';
import { update } from '../../helpers/immutabilityHelper';

import {
    PROJECT_SETTINGS_PAGE_SET_TRIAL
} from '../../actions/pages/projectSettingsPage';


export interface IProjectSettingsPageState {
    projectId: number;
}

const initialState: IProjectSettingsPageState = {
    projectId: undefined
};

function setTrial(state: IProjectSettingsPageState, projectId: number): IProjectSettingsPageState {
    const newState: IProjectSettingsPageState = update(state, {
        projectId: {
            $set: projectId
        }
    });
    return newState;
}

const ProjectSettingsPageReducer: Reducer<IProjectSettingsPageState> = (state: IProjectSettingsPageState = initialState, action) => { 
    switch (action.type) {
        case PROJECT_SETTINGS_PAGE_SET_TRIAL:
            return setTrial(state, action.projectId);
    }

    return state;
}

export default ProjectSettingsPageReducer;